import { render, staticRenderFns } from "./SystemSettingEdit.vue?vue&type=template&id=089fc9bc"
import script from "./SystemSettingEdit.vue?vue&type=script&lang=js"
export * from "./SystemSettingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports